import { InputRichText } from '@dixa/lib-shared-habla';
import { RefObject, useCallback, useContext, useEffect } from 'react';
import { useMount } from 'react-use';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { MentionsTrigger } from './components/mentionsTrigger/mentionsTrigger';
import { shouldHandleSelectionChange } from './utils/mentions.utils';

export const EditorMentions = ({
  container,
}: {
  container?: RefObject<HTMLElement>;
}): null => {
  const { conversationNoteMentions } = useFeatureFlag([
    'conversation-note-mentions',
  ]);
  const editorContext = useContext(InputRichText.Context);

  const createTrigger = useCallback(
    () => ({
      id: 'conversation-mentions',
      trigger: /(^|\s)(@$|@\S)/,
      minChars: 0,
      allowSpaces: true,
      component: <MentionsTrigger />,
      persistOnEsc: false,
      customContainer: container,
      shouldHandleSelectionChange: () =>
        shouldHandleSelectionChange(
          editorContext.selection.recreate({ focus: false }),
        ),
    }),
    [editorContext.selection, container],
  );

  useMount(() => {
    if (!conversationNoteMentions) return;

    editorContext.triggers.add(createTrigger());
  });

  useEffect(() => {
    if (!conversationNoteMentions) return;

    editorContext.triggers.update(createTrigger());
  }, [createTrigger, editorContext.triggers, conversationNoteMentions]);

  return null;
};
